'use client';
import { useEffect, useState } from 'react';
import { TrendingUp, Users, Leaf, Award } from 'lucide-react';

const stats = [
  { value: 12847, label: 'সক্রিয় কৃষক', suffix: '+', icon: Users, color: 'text-green-200' },
  { value: 94, label: 'নির্ভুলতার হার', suffix: '%', icon: Award, color: 'text-amber-300' },
  { value: 48392, label: 'ফসল বিশ্লেষণ', suffix: '+', icon: Leaf, color: 'text-green-200' },
  { value: 23, label: 'রোগ শনাক্ত করে', suffix: '+', icon: TrendingUp, color: 'text-amber-300' },
];

function AnimatedCounter({ target, suffix }: { target: number; suffix: string }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const duration = 1500;
    const steps = 40;
    const increment = target / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);
    return () => clearInterval(timer);
  }, [target]);

  return (
    <span className="tabular-nums">
      {count.toLocaleString('bn-BD')}{suffix}
    </span>
  );
}

export default function StatsBar() {
  return (
    <section className="bg-gradient-to-r from-green-700 via-green-600 to-emerald-600 py-8 sm:py-10">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8">
          {stats.map((stat, i) => (
            <div key={i} className="text-center group cursor-default">
              <div className="flex items-center justify-center gap-2 mb-2">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-all duration-300 group-hover:scale-110">
                  <stat.icon size={18} className={stat.color} />
                </div>
              </div>
              <p className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-1 group-hover:scale-105 transition-transform duration-300">
                <AnimatedCounter target={stat.value} suffix={stat.suffix} />
              </p>
              <p className="text-green-200 text-xs sm:text-sm font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}